require("./bundles/visits/index.jsx");
